<template>
  <div class="main">
    <div style="height: 10px"></div>
    <div class="user_info_div">
      <div class="huanying">
        😉 亲爱的<span class="username_1">{{ userinfo.name }}</span
        >，欢迎来到大象系统个人中心，日常使用中，也可点击页面左下角头像回到本页面。
      </div>
      <div class="quit_box" @click="quit_button">
        <span class="quit_txt">
          <Icon type="ios-power" style="font-weight: 600; font-size: 16px" /> 退出登录
        </span>
      </div>
    </div>

    <div class="user_main_box">
      <div class="user_left_box">
        <div class="user_avatar_div">
          <div>
            <img class="user_avatar" :src="userinfo.avatar" alt="头像" />
          </div>
          <div class="user_name">
            {{ userinfo.name }}
          </div>
          <div class="team_div">
            <div class="team_list" v-if="userinfo.dep_data">
              <div class="team_list_title">手机号：</div>
              <Icon type="md-phone-portrait" />
              {{ phone }}

              <!-- <Icon style="margin-left: 3px;" type="md-checkmark-circle-outline" color="green" /> -->
            </div>
            <div class="team_list" v-if="userinfo.dep_data">
              <div class="team_list_title">部门：</div>
              {{ userinfo.dep_data.team_name }}
              <span v-if="userinfo.dep_data.dep_name"
                >/ {{ userinfo.dep_data.dep_name }}</span
              >
            </div>
          </div>
          <div class="user_options_div">
            <a target="_blank" class="user_options_a" @click="change_pwd">
              <Icon type="md-key" />
              修改密码
            </a>
            <a
              href="/admin_login"
              v-if="userinfo.is_super_admin == 1"
              target="_blank"
              class="user_options_a"
            >
              <Icon type="md-swap" />
              管理后台
            </a>
          </div>
        </div>

        <div class="wallet">
          <div class="wallet_money">
            <img class="tongzhi_icon" src="@/assets/image/user/tongzhi.png" alt="" />
            <div>
              <span class="xxtsy">消息提示音：{{ notify_mp3_item.name }}</span>

              <span class="cutmp3" @click="cut_notify()">
                <Tooltip content="切换提示音" placement="top-start">
                  <Icon
                    style="margin-left: 3px"
                    size="18"
                    color="#0466dd"
                    type="md-repeat"
                  />
                </Tooltip>
              </span>
            </div>
          </div>
        </div>

        <div class="wallet">
          <div class="wallet_money">
            <img class="wallet_icon" src="@/assets/image/user/wallet.png" alt="" />
            <div class="wallet_money_txt">
              ￥<span class="wallet_money_count">{{ balance }}</span>
            </div>
            <div class="chongzhi" @click="click_chongzhi">充值</div>
          </div>
        </div>

        <div class="calendar_div">
          <div class="title_div2">
            <div class="title_icon"></div>
            {{ current_month }}月登录日历
          </div>
          <div class="calendar2">
            <div class="calendar">
              <Calendar :cell-height="40" :show-header="false">
                <template #month="{ data }">
                  <div class="login_calendar">
                    <div v-for="i in login_date_list" :key="i">
                      <Icon
                        type="md-checkmark-circle"
                        class="login_calendar_icon"
                        color="#0466dd"
                        v-if="data.day == i"
                        size="13"
                      />
                    </div>
                  </div>
                </template>
              </Calendar>
            </div>
          </div>
        </div>

        <div class="calendar_div2">
          <div class="title_div2">
            <div class="title_icon"></div>
            微信反馈群
          </div>
          <div class="group_im_div">
            <Spin fix v-if="img_group_loading" />

            <img v-if="im_group_url" class="group_im_img" :src="im_group_url" alt="" />
            <div v-else class="group_im_img"></div>
          </div>
        </div>
      </div>
      <div class="user_right_box">
        <div class="sys_select">
          <div class="title_div">
            <div class="title_icon"></div>
            <span> 大象HRO </span>
            <span
              style="
                margin-left: 5px;
                font-size: 13px;
                font-weight: 400;
                color: rgb(191, 191, 191);
              "
              >（当前在线人数：{{ online_count }}人）</span
            >
          </div>
          <div class="sys_btn_main">
            <div
              v-for="(item, i) in sys_list"
              :key="i"
              class="sys_btn_box"
              @click="click_sys(item, i)"
            >
              <div class="sys_btn_div" v-if="!item.sys_auth">
                <Icon type="md-lock" class="sys_lock_icon" />
              </div>
              <!-- <div style="background: #e2e2e2" class="sys_btn" v-if="!item.sys_auth">
                <div class="sys_icon_innner">
                  <img :src="item.img" alt="" class="sys_icon" />
                </div>
                <div class="sys_name_inner">
                  {{ item.name }}
                </div>
              </div> -->
              <div :style="'background:' + item.color" class="sys_btn">
                <div class="sys_icon_innner">
                  <img :src="item.img" alt="" class="sys_icon" />
                </div>
                <div class="sys_name_inner">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sys_select">
          <div class="title_div">
            <div class="title_icon"></div>
            <span> 大象猎聘</span>
            <span
              style="
                margin-left: 5px;
                font-size: 13px;
                font-weight: 400;
                color: rgb(191, 191, 191);
              "
              >（当前在线人数：{{ online_count }}人）</span
            >
          </div>
          <div class="sys_btn_main">
            <div
              v-for="(item, i) in liepin_sys_list"
              :key="i"
              class="sys_btn_box"
              @click="click_sys(item, i)"
            >
              <div class="sys_btn_div" v-if="!item.sys_auth">
                <Icon type="md-lock" class="sys_lock_icon" />
              </div>
              <!-- <div style="background: #e2e2e2" class="sys_btn" v-if="!item.sys_auth">
                <div class="sys_icon_innner">
                  <img :src="item.img" alt="" class="sys_icon" />
                </div>
                <div class="sys_name_inner">
                  {{ item.name }}
                </div>
              </div> -->
              <div :style="'background:' + item.color" class="sys_btn">
                <div class="sys_icon_innner">
                  <img :src="item.img" alt="" class="sys_icon" />
                </div>
                <div class="sys_name_inner">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="rili_div">
          <div class="sys_select3">
            <div class="title_div2">
              <div class="title_icon"></div>
              消息通知
            </div>
            <div class="xiaoxi">
              <Alert type="success"
                >1、大象系统APP已经上线使用，可到官网下载安装。
                <a href="https://www.daxiangsys.com" target="_blank">点击前往 >></a>
              </Alert>
            </div>
          </div>
        </div> -->
        <div class="download_div">
          <div class="title_div">
            <div class="title_icon"></div>
            相关下载
          </div>
          <div>
            <div class="download_icon_box">
              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_app('android')"
              >
                <div>
                  <span class="iconfont iconanzhuo loginicon"></span>
                </div>
                <span class="login_text">安卓APP下载</span>
              </div>
              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_app('ios')"
              >
                <div>
                  <span class="iconfont iconpingguo loginicon"></span>
                </div>
                <span class="login_text">苹果APP下载</span>
              </div>

              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_app('win')"
              >
                <div>
                  <span class="iconfont iconwin loginicon"></span>
                </div>
                <span class="login_text">Windows下载</span>
              </div>
              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_app('mac')"
              >
                <div>
                  <span class="iconfont iconmac loginicon"></span>
                </div>
                <span class="login_text">Mac下载</span>
              </div>

              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_mp('dxxt')"
              >
                <div>
                  <span class="iconfont icongongzhonghao loginicon"></span>
                </div>
                <span class="login_text">大象系统</span>
              </div>

              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_mp('dxygfwzx')"
              >
                <div>
                  <span class="iconfont icongongzhonghao loginicon"></span>
                </div>
                <span class="login_text">员工服务中心</span>
              </div>
              <div
                class="login_box_inner login_box_inner_hover"
                @click="click_download_mp('dxhbfw')"
              >
                <div>
                  <span class="iconfont icongongzhonghao loginicon"></span>
                </div>
                <span class="login_text">伙伴服务中心</span>
              </div>
            </div>
          </div>
        </div>

        <div class="sys_select2">
          <div class="title_div2">
            <div class="title_icon"></div>
            帐号安全
          </div>
          <div class="login_device">
            <div class="login_device_title">
              1、帐号当前状态：
              <br />
              <span style="color: #ccc; font-size: 12px; margin-left: 20px"
                >为安全起见，同一个平台，尽量保留一个登录状态，可手动把认为不安全的踢下线！</span
              >
            </div>

            <div class="login_device_margin">
              <Table stripe :columns="columns" :data="account_list" size="small">
                <template #action="{ row }">
                  <Button
                    size="small"
                    style="font-size: 10px"
                    @click="click_del_token(row)"
                    type="error"
                    >踢下线</Button
                  >
                </template>
              </Table>
            </div>
          </div>

          <div class="login_device">
            <div class="login_device_title">
              2、帐号登录记录：
              <br />
              <!-- <span style="color:#ccc;font-size: 12px;margin-left:20px">为安全起见，同一个平台，只会保留一个登录状态，超过将被挤下线！</span> -->
            </div>

            <div>
              <Table
                stripe
                height="200"
                :columns="record_columns"
                :data="record_list"
                size="small"
              >
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="cut_notify_show" title="切换提示音" :footer-hide="true" width="320">
      <!-- {{ shiting_mp3_item }} -->
      <div>
        <Select
          v-model="shiting_mp3_item.mp3_id"
          style="width: 150px"
          @on-change="notify_mp3_change"
        >
          <Option
            v-for="item in notify_mp3_item.mp3_list"
            :value="item.mp3_id"
            :key="item.mp3_id"
            >{{ item.name }}</Option
          >
        </Select>
        <Button @click="click_shiting" style="margin-left: 10px"
          ><Icon type="ios-headset" /> 试听</Button
        >
      </div>
      <audio v-if="shiting_show" id="notify_mp3_shiting" controls style="display: none">
        <source :src="shiting_mp3_item.url" type="audio/mpeg" />
      </audio>
      <div class="ModalButton">
        <Button type="primary" @click="update_notify_mp3">确认保存</Button>
      </div>
    </Modal>

    <Modal
      v-model="qrcode_show"
      :title="qrcode_show_title"
      :footer-hide="true"
      width="320"
    >
      <div class="qrcode_div">
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <div class="qrcode_tishi">
        <span v-if="download_status == 'ios'"
          >使用苹果相机扫一扫，用Safari浏览器打开，需要搭配苹果官方测试APP【TestFlight】一同使用，不可卸载</span
        >
        <span v-if="download_status == 'android'"
          >使用安卓手机扫一扫，下载APK安装包进行安装</span
        >
      </div>
      <!-- <div style="margin-top: 10px">
        1、苹果手机请用默认浏览器打开，按流程安装，注意安装成功后不可以卸载【TestFlight】，否则后续无法自动更新
        <br />
        2、安卓手机请允许外部应用安装
      </div> -->
    </Modal>

    <Modal
      width="350"
      v-model="wxmp_qrcode_show"
      :mask-closable="true"
      title="微信公众号二维码"
      :closable="true"
      :footer-hide="true"
    >
      <div>
        <img
          v-if="wxmp_qrcode_status == 'dxxt'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_wxmp.png"
          alt=""
        />
        <img
          v-if="wxmp_qrcode_status == 'dxygfwzx'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_wxygfwzx.png"
          alt=""
        />
        <img
          v-if="wxmp_qrcode_status == 'dxhbfw'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_huobanfuwu.png"
          alt=""
        />
      </div>
    </Modal>

    <Modal
      width="420"
      v-model="bind_wx_status"
      :mask-closable="false"
      title="绑定微信公众号"
      :closable="false"
      :footer-hide="true"
    >
      <div class="bind_wx_status_title">
        您还没有关注大象系统微信公众号，公众号通知可能无法接收 <br />
        请使用微信扫一扫关注
        <br />
        <span>绑定成功后，刷新(F5)当前页面即可关闭弹窗~！</span>
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="!bind_qr"></Spin>
        <div class="bind_qr_img">
          <img :src="bind_qr" alt="" class="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </Modal>

    <Modal
      width="420"
      v-model="bind_dingding_status"
      :mask-closable="false"
      :closable="false"
      title="绑定钉钉用户"
      :footer-hide="true"
    >
      <div class="bind_wx_status_title">
        您还没有绑定钉钉，钉钉通知无法接收， <br />
        <span class="iconfont icondingding"></span>请使用钉钉扫一扫进行绑定！
        <br />
        <span>绑定成功后，刷新(F5)当前页面即可关闭弹窗~！</span>
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="!bind_dingding_qr"></Spin>
        <div class="bind_qr_img">
          <img
            :src="bind_dingding_qr"
            alt=""
            class=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </Modal>

    <Modal
      draggable
      width="350"
      v-model="chongzhi_show"
      :mask-closable="false"
      title="充值"
      :footer-hide="true"
    >
      <div class="chongzhi_div">
        <div>金额(元)：</div>
        <InputNumber
          style="width: 120px"
          :max="10000"
          :min="0.01"
          :step="0.01"
          v-model="chongzhi_money"
        />
        <Button @click="wxpay_xiadan" style="margin-left: 10px" type="primary"
          >确认</Button
        >
      </div>
      <div class="qrcode_wxpay_main" v-if="chongzhi_qr_url">
        <div class="qrcode_wxpay">
          <div ref="qrCodeUrl" class="qrcode_img" alt=""></div>
        </div>
        <div class="qrcode_wxpay">
          <span class="iconfont iconweixinzhifu"></span>
        </div>
        <div class="qrcode_wxpay_detail">微信扫一扫，支付成功请刷新页面查看余额</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page, get_browser_id } from "@/utils/http.js";
import QRCode from "qrcodejs2";
import { Base64 } from "js-base64";

export default {
  components: {},
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      sys_list: [],
      liepin_sys_list: [],
      userinfo: {
        name: "",
      },

      bind_wx_status: false,
      bind_qr: "",

      columns: [],
      account_list: [],

      record_columns: [],
      record_list: [],

      login_date_list: [],
      current_month: "-",
      phone: "-",
      im_group_url: "",
      img_group_loading: true,

      balance: "0.00",

      chongzhi_show: false,
      description: "大象用户自行充值",
      chongzhi_money: 0,
      chongzhi_qr_url: "",

      // 在线数
      online_count: 0,

      // 绑定钉钉
      bind_dingding_status: false,
      bind_dingding_qr: "",
      wxmp_qrcode_show: false,
      wxmp_qrcode_status: "",
      qrcode_show: false,
      download_status: "",
      qrcode_show_title: "",

      //
      notify_mp3_item: {
        name: "",
        mp3_id: "",
        mp3_list: [],
      },
      shiting_show: true,
      shiting_mp3_item: {
        mp3_id: "",
        url: "",
      },
      cut_notify_show: false,
    };
  },

  mounted() {
    this.$router.push({ path: "/user/index/v2" });

    this.window_change();

    this.get_sys_list();
    this.get_user_data();
    this.get_account_status_list();
    this.get_login_record_list();
    this.get_login_calendar();
    this.get_im_group();
    this.get_bind_wx_status();
    this.get_bind_dd_status();
    this.get_user_balances();
    this.get_online_count();
    this.get_notify_mp3();
  },

  methods: {
    notify_mp3_change(e) {
      console.log(e);
      var that = this;
      if (e) {
        for (var i = 0; i < this.notify_mp3_item.mp3_list.length; i++) {
          var item = this.notify_mp3_item.mp3_list[i];
          console.log(item);
          if (item.mp3_id == e) {
            this.shiting_mp3_item.mp3_id = item.mp3_id;
            this.shiting_mp3_item.url = item.url;
            console.log(this.shiting_mp3_item);
            this.shiting_show = false;
            setTimeout(function () {
              that.shiting_show = true;
            }, 100);

            break;
          }
        }
      }
    },

    // 试听
    click_shiting() {
      this.shiting_show = false;
      this.shiting_show = true;
      console.log(this.shiting_mp3_item);
      var audioElement = document.getElementById("notify_mp3_shiting");
      audioElement.play().catch((error) => {
        console.log(error);
      });
    },

    // 获取通知铃声
    get_notify_mp3() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/notify_mp3_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            this.notify_mp3_item = res.data;
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取在线人数
    get_online_count() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/online_count",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            this.online_count = res.data.count;
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 下单
    wxpay_xiadan() {
      if (this.chongzhi_money == 0) {
        this.$Message.warning("请填写金额");
        return;
      }

      var that = this;
      var obj = {
        description: this.description,
        money: this.chongzhi_money,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/wxpay_jsapi_xiadan",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            if (that.chongzhi_qr_url) {
              that.$refs.qrCodeUrl.innerHTML = "";
            }
            console.log(url);
            that.chongzhi_qr_url = url;
            setTimeout(() => {
              var qrcode = new QRCode(that.$refs.qrCodeUrl, {
                text: that.chongzhi_qr_url, // 需要转换为二维码的内容
                width: 199,
                height: 199,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
            }, 1);
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_chongzhi() {
      this.chongzhi_show = true;
    },

    // 获取用户余额
    get_user_balances() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/user_balances",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.balance = res.data.balance;
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_im_group() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/login_dx/im_group", obj, true, "staff")
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.im_group_url = res.data.url;
            that.img_group_loading = false;
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_login_calendar() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/login_calendar",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.current_month = res.data.current_month;
            that.login_date_list = res.data.date_list;
            that.phone = res.data.phone;
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_del_token(row) {
      var that = this;
      this.$Modal.confirm({
        title: "操作提示",
        content: "<p>操作后，对应的平台帐号登录状态将失效，需要重新登录，是否继续？</p>",
        onOk: () => {
          that.del_toekn_request(row.platform, row.login_time_tsp);
        },
        onCancel: () => {},
      });
    },

    del_toekn_request(platform, login_time) {
      var that = this;
      var obj = {
        login_time: login_time,
        platform: platform,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/del_token",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.info(res.msg);

            setTimeout(function () {
              that.get_account_status_list();
            }, 1000);

            // that.sys_list = res.data.sys_list
            // that.user_info = res.data.user_info
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    quit_request() {
      var that = this;
      var obj = {
        dx_browser_id: this.$cookies.get(
          "dx_browser_id",
          "/",
          process.env.VUE_APP_COOKIES_DOMAIN
        ),
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/staff_quit",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.info(res.msg);
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_account_status_list() {
      console.log("获取系统列表");
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/account_status_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            var account_list = res.data.account_list;
            this.account_list = account_list;
            this.columns = res.data.columns;
            // that.sys_list = res.data.sys_list
            // that.user_info = res.data.user_info
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取登录记录
    get_login_record_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/login_record",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.record_list = res.data.record_list;
            this.record_columns = res.data.columns;
            // that.sys_list = res.data.sys_list
            // that.user_info = res.data.user_info
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击切换系统
    click_sys(item, i) {
      if (item.sys_auth) {
        var url = item.url;
        this.$emit("change", "open");
        open_new_page(url, "_blank");
      } else {
        this.$Message.error("没有这个系统登录权限");
      }
    },

    get_user_data() {
      var userinfo = this.$cookies.get("dx_user_info");
      if (userinfo != "undefined") {
        this.userinfo = userinfo;
      }
    },

    get_sys_list() {
      console.log("获取系统列表");
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/login_dx/web_sys_list/v2",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.sys_list = res.data.hro_sys_list;
            that.liepin_sys_list = res.data.liepin_sys_list;
            that.user_info = res.data.user_info;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 检查绑定钉钉状态
    get_bind_dd_status() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_dingding_status",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_dingding_status = !res.data.bind_status;

            if (that.bind_dingding_status == true) {
              that.get_bind_dingding_qr();
            }

            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 检查绑定微信状态
    get_bind_wx_status() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_wx_status",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_wx_status = !res.data.bind_status;

            if (that.bind_wx_status == true) {
              that.get_bind_wx_qr();
            }

            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_wx_qr() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_wx_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_qr = res.data.qr_b64;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_dingding_qr() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_dingding_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_dingding_qr = res.data.qr_b64;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //确认退出
    quit_button() {
      var that = this;
      get_browser_id();
      console.log(process.env.VUE_APP_COOKIES_DOMAIN);

      this.$Modal.confirm({
        width: 330,
        title: "提示",
        content: "<p>您正在退出登录，退出后需重新登录帐号，确认继续吗？</p>",
        onOk: () => {
          that.quit_request();

          that.del_cookie();
        },
        onCancel: () => {},
      });
    },

    del_cookie() {
      var that = this;
      that.$cookies.remove("dx_token", {
        path: "/",
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
      });
      that.$cookies.remove("dx_private_key", {
        path: "/",
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
      });
      that.$cookies.remove("dx_public_key", {
        path: "/",
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
      });
      that.$cookies.remove("dx_user_info", {
        path: "/",
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
      });
      setTimeout(function () {
        that.$router.push({
          path: "/",
        });
      }, 1000);
    },
    click_download_app(status) {
      this.download_status = status;
      var that = this;
      var obj = {
        download_status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/download",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            if (that.download_status == "android") {
              that.qrcode_show_title = "大象安卓APP扫码下载";
              var urlb64 = Base64.encode(res.data.download_url);
              var download_str = encodeURIComponent(urlb64);

              var url = "https://www.daxiangsys.com/app/download?url=" + download_str;

              this.$refs.qrCodeUrl.innerHTML = "";
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: url, // 需要转换为二维码的内容
                width: 150,
                height: 150,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              that.qrcode_show = true;
            }

            if (that.download_status == "ios") {
              that.qrcode_show_title = "大象苹果APP扫码下载";
              var url = res.data.download_url;

              this.$refs.qrCodeUrl.innerHTML = "";
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: url, // 需要转换为二维码的内容
                width: 150,
                height: 150,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              that.qrcode_show = true;
            }

            if (that.download_status == "win") {
              that.qrcode_show_title = "Win7、Win10、Win11下载";
              var url = res.data.download_url;

              this.$Modal.confirm({
                title: "提示",
                content: "<p>是否下载[大象Win]安装包？下载后双击完装即可。</p>",
                onOk: () => {
                  open_new_page(url);
                },
                onCancel: () => {},
              });
            }
            if (that.download_status == "mac") {
              that.qrcode_show_title = "苹果MAC系统下载";
              var url = res.data.download_url;

              this.$Modal.confirm({
                title: "提示",
                content: "<p>是否下载[大象MAC]安装包？下载后双击完装即可。</p>",
                onOk: () => {
                  open_new_page(url);
                },
                onCancel: () => {},
              });
            }
          } else {
            that.$Message.info(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    change_pwd() {
      open_new_page("/user/change_pwd");
    },

    click_download_mp(status) {
      this.wxmp_qrcode_show = true;
      this.wxmp_qrcode_status = status;
    },

    //编辑用户信息
    editor_user_info() {
      this.$Message.info("暂不支持编辑用户信息");
    },

    // 切换提示音
    cut_notify() {
      this.cut_notify_show = true;
      this.shiting_mp3_item.mp3_id = this.notify_mp3_item.mp3_id;
      this.shiting_mp3_item.url = this.notify_mp3_item.url;
      this.shiting_show = false;
      var that = this;
      setTimeout(function () {
        that.shiting_show = true;
      }, 100);
    },

    update_notify_mp3() {
      var that = this;
      var obj = {
        mp3_id: this.shiting_mp3_item.mp3_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/update_notify_mp3",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.cut_notify_show = false;
            that.get_notify_mp3();
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.xxtsy {
  color: #888;
}

.ModalButton {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.cutmp3 {
  cursor: pointer;
}

.qrcode_tishi {
  font-size: 13px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.qrcode_div {
  display: flex;
  justify-content: center;
}

.wxmp_qr_img {
  width: 100%;
  border-radius: 10px;
}

.loginicon {
  font-size: 24px;
}

.iconanzhuo {
  color: #2b9c25;
}

.iconmac {
  color: #000;
}

.iconpingguo {
  color: #000;
}

.iconwin {
  color: #5ca5ff;
}
.login_text {
  color: #8e8e8e;
  font-size: 13px;
}

.icongongzhonghao {
  color: #0dcc60;
}

.login_box_inner {
  width: 120px;
  flex-shrink: 0;

  text-align: center;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 1px #9f9f9f;
  margin: 10px;
  cursor: pointer;
}

.login_box_inner:hover {
  box-shadow: 0 0 2px #0466dd;
}

.download_icon_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.download_div {
  background: #fff;
  border-radius: 8px;
  padding: 10px;
}

.huanying {
  font-size: 13px;
}

.icondingding {
  color: #0466dd;
  font-size: 16px;
}

.qrcode_wxpay_main {
  margin: 20px 0 0 20px;
}

.iconweixinzhifu {
  color: #14a954;
  font-size: 30px;
}

.qrcode_wxpay {
  display: flex;
  justify-content: center;
}

.qrcode_wxpay_detail {
  display: flex;
  font-size: 13px;
  color: #333;
  justify-content: center;
}

.qrcode_img {
  width: 200px;
  height: 200px;
  text-align: center;
  border: 1px solid #ccc;
}

.chongzhi_div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chongzhi {
  cursor: pointer;
  margin: 5px 0 0px 10px;
  padding: 0 10px;
  background: #cacaca;
  font-size: 13px;
  color: #fff;
  border-radius: 30px;
}

.wallet_money_count {
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}

.wallet_money_txt {
  font-size: 16px;
  padding-top: 10px;
  color: #383838;
}

.wallet_money {
  display: flex;
  align-items: center;
}

.wallet_icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.tongzhi_icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.wallet {
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 10px;
  background: #fff;
}
.bind_wx_status_title {
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}

.bing_qr_img_div {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  position: relative;
}

.bind_qr_img {
  width: 120px;
  height: 120px;
  border: 1px solid #989898;
}

.group_im_div {
  text-align: center;
  position: relative;
}

.group_im_img {
  width: 250px;
  height: 400px;
}

.user_options_a {
  color: #fff;
  font-size: 12px;
  margin-right: 10px;
  padding: 2px 10px;
  border-radius: 10px;
  background-color: #0466dd;
}

.user_options_a:hover {
  background-color: #0466dd;

  color: #fff;
}

.user_options_div {
  margin-top: 10px;
  padding-top: 7px;
  display: flex;
  border-top: 1px solid #f8f8f8;
}

.calendar_div {
  background-color: white;
  border-radius: 10px;
  margin: 10px 0;
  padding: 5px 0 10px 5px;
}

.calendar_div2 {
  background-color: white;
  border-radius: 10px;
  margin: 10px 0;
  padding: 5px 0 0px 5px;
}

.team_div {
  border-top: 1px dashed #f0f0f0;
  margin-top: 10px;
  padding-top: 10px;
  text-align: left;
}

.team_list_title {
  width: 55px;
  flex-shrink: 0;
}

.team_list {
  font-size: 13px;
  display: flex;
  color: #888;
  align-items: center;
}

.user_name {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
}

.user_avatar_div {
  height: 215px;
  text-align: center;
  border: 1px solid #f8f8f8;
  padding: 15px 20px 20px 20px;
  border-radius: 10px;
  background-color: white;
  cursor: pointer;
}

/* .user_avatar_div:hover {
    border: 1px dashed #026bf5
} */

.user_right_box {
  width: calc(100% - 300px);
  padding-left: 10px;
  /* height: calc(100vh - 75px);
    overflow: auto; */
  /* padding-right: 30px; */
}

.user_main_box {
  overflow: auto;
  height: calc(100vh - 75px);
  padding-right: 10px;
  display: flex;
}

.login_calendar_icon {
  position: relative;
  top: -6px;
}

.user_left_box {
  /* margin-left: 30px; */
  width: 290px;
  padding-left: 20px;
  /* margin-right: 10px; */
  flex-shrink: 0;
  border-radius: 10px;
}

.xiaoxi {
  padding: 10px 10px;
  text-align: center;
  color: #888;
  display: flex;
}

.login_calendar {
  /* background-color: #0466dd;
    border-radius: 50px;
    text-align: center;
    position: relative;
    top: -2px; */
  /* background-color: #0466dd; */
  /* width: 20px; */
  /* height: 20px; */
  /* border-radius: 50%; */
}

.rili_div {
  display: flex;
}

.calendar2 {
  display: flex;
  justify-content: center;
}

.calendar {
  text-align: center;
  width: 280px;

  padding: 0 10px;
}

.quit_box {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 10px 10px 0;
  width: 110px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(216, 14, 14);
}

.quit_txt {
  font-size: 14px;
  color: white;
  cursor: pointer;
  float: right;
}

.login_device_title {
  font-size: 13px;
  color: #333;
  margin-bottom: 10px;
}

.login_device_margin {
  max-height: 250px;
  overflow: auto;
}

.login_device {
  padding: 10px 20px 10px 10px;
}

.margin_bt {
  margin-bottom: 15px;
}

.title_div {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 15px;
  padding-bottom: 10px;
  margin-bottom: 0px;
  border-bottom: 1px solid #f5f5f5;
}

/deep/ .ivu-calendar-table thead th {
  padding: 6px 0 6px 6px;
}

.title_div2 {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ede5e5;
}

.user_avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.title_icon {
  border-radius: 3px;
  margin-right: 10px;
  height: 15px;
  width: 8px;
  background-color: #0466dd;
}

.anquan_icon {
  color: #dfdfdf;
}

.username_1 {
  color: #026bf5;
}

.user_info_div {
  margin: 0 20px 10px 20px;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #fff;

  position: relative;
}

.main {
  min-width: 800px;
  height: 100vh;
  overflow: auto;
  background: radial-gradient(circle, #e2dbdb 10%, transparent 11%),
    radial-gradient(circle at bottom left, #e2dbdb 5%, transparent 6%),
    radial-gradient(circle at bottom right, #e2dbdb 5%, transparent 6%),
    radial-gradient(circle at top left, #e2dbdb 5%, transparent 6%),
    radial-gradient(circle at top right, #e2dbdb 5%, transparent 6%);
  background-size: 1em 1em;
  background-color: #e7eaf0;
  /* background-color: #f1f1f1; */
}

.sys_select {
  padding: 10px 10px 10px 10px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 10px;

  /* min-height: 215px; */
}

.sys_select2 {
  margin-top: 10px;
  width: 100%;
  padding: 10px 10px 20px 0px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.sys_select3 {
  width: 100%;
  padding: 10px 0px 20px 10px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  flex-shrink: 0;
}

.group_img_close {
  position: relative;
  top: 35px;
  right: 10px;
  text-align: right;
  cursor: pointer;
}

.group_img {
  border-radius: 10px;
  box-shadow: 0 0 3px #ccc;
  width: 260px;
  height: 400px;
}

.group_img_div {
  text-align: center;
  position: fixed;
  right: 15px;
  top: 190px;
}

.sys_btn_div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sys_lock_icon {
  position: absolute;
  font-size: 18px;
  top: 3%;
  right: 1px;
  color: #ffffff;
  opacity: 0.7;
}

.sys_btn_box {
  margin: 10px 10px 10px 5px;
  cursor: pointer;
  position: relative;
}

.sys_btn_box:hover {
  border-radius: 10px;
  box-shadow: 0 0 5px #ccc;
}

.sys_btn_main {
  display: flex;
  flex-wrap: wrap;
}

.sys_name_inner {
  display: flex;
  justify-content: center;
  margin-top: 5px;
  font-size: 13px;
}

.sys_icon_innner {
  display: flex;
  justify-content: center;
}

.sys_icon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
}

.sys_btn {
  padding: 15px 0px 10px 0px;
  width: 90px;
  color: #fff;
  border-radius: 10px;
}
</style>
